import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbAssetsReportsUnsubscribeRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-assets-reports-unsubscribe',
	path: '/jira/servicedesk/assets/reports/unsubscribe/:templateId/:subscriptionId',
	exact: true,
};
